import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Checkbox } from '@mui/material';
import CzyFormControl from '../../../../../../common/CzyForm/CzyFormControl';
import { generateEntitySelect } from '../../../../../../common/CzyForm/EntitySelect';
import NullableTextField from '../../../../../../common/CzyForm/NullableTextField';
import { COLORS } from '../../../../../../common/Styleguide/Common/colors';
import { TagListData } from '../../TagCategory/tag-category-graphql';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { StyledHeaderTextH2 } from '../../../../../../common/Styleguide/Common/Text';

export function renderLink(value: string | null, label: string, onChange: (text: string | null) => void) {
  return <NullableTextField margin="dense" defaultValue={value} onChange={onChange} fullWidth label={label} />;
}

export const CollectionSelector = generateEntitySelect<TagListData>(
  (tag: TagListData) => tag.id,
  (tag: TagListData) => tag.defaultName,
  true,
  'start',
);

export const renderNullableTextField = (value: string | null, label: string, onChange: (text: string | null) => void, tooltip?: string) => {
  return (
    <CzyFormControl label={label} tooltip={tooltip}>
      <NullableTextField margin="normal" defaultValue={value} onChange={onChange} fullWidth />
    </CzyFormControl>
  );
};

export const cleanSEOKeyword = (keyword: string) => {
  return (
    keyword
      // eslint-disable-next-line
      .replace(/[`\-!*()_?;:'",.\\\/]/gi, ' ')
      .replace(/\s\s+/g, ' ') // remove multiple spaces
  );
};

export const renderError = (error: string | null) => {
  if (!error) {
    return null;
  }
  return <div style={{ color: COLORS.alert[100] }}>{error}</div>;
};

interface AccordionSectionProps {
  id?: string;
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({ title, defaultExpanded, children, id }: AccordionSectionProps) => {
  return (
    <Accordion defaultExpanded={defaultExpanded} id={id}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`${id}-accordion-header`}>
        <StyledHeaderTextH2 sx={{ my: 0 }}>{title}</StyledHeaderTextH2>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export const renderCheckbox = (value: boolean, label: string, onChange: (newValue: boolean) => void) => {
  return <FormControlLabel control={<Checkbox checked={value} onChange={(e) => onChange(e.currentTarget.checked)} />} label={label} />;
};
